import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getUserData, getUserDetails } from '../../../../utils';
import { makeReadNotificationsAsync } from '../../../store/slices/common/notificationsSlice';
import { setOpenAllProfilesModal } from '../../../store/slices/common/userProfileSlice';

// Dynamic imports
const BottomNav = dynamic(() => import('./BottomNav/BottomNav'), {
  loading: () => <div className='fixed bottom-0 min-h-[64px] md:hidden'></div>,
});
const TopNav = dynamic(() => import('./TopNav'), {
  loading: () => <div className='min-h-[211px]'></div>,
});
const AllProfilesModal = dynamic(() => import('../../Common/AllProfilesModal'));
const DowngradeSubscriptionNotificationModal = dynamic(
  () => import('../../GiftAds/DowngradeSubscriptionNotificationModal')
);
const GiftAdsNotificationModal = dynamic(
  () => import('../../GiftAds/GiftAdsNotificationModal')
);
const UpgradeSubscriptionNotificationModal = dynamic(
  () => import('../../GiftAds/UpgradeSubscriptionNotificationModal')
);

const NavBar = () => {
  const dispatch = useDispatch();
  const router = useRouter();
  const isFromLandingPage = router.pathname === '/';
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const [openNotificationMenu, setOpenNotificationMenu] = useState(false);
  const [openCongratsModal, setOpenCongratsModal] = useState(false);
  const [subscriptionDowngradeModal, setSubscriptionDowngradeModal] =
    useState(false);
  const [subscriptionUpgradeModal, setSubscriptionUpgradeModal] =
    useState(false);
  const [giftAdDetails, setGiftAdDetails] = useState(null);
  const [subscriptionDetails, setSubscriptionDetails] = useState(null);

  const userDetailsFromApi = useSelector(({ userProfile }) => {
    return userProfile?.userDetails;
  });
  const userDetailsFromLocal = getUserDetails();

  const userDetails = userDetailsFromLocal || userDetailsFromApi;

  const userData = getUserData();

  const openAllProfilesModal = useSelector(({ userProfile }) => {
    return userProfile?.openAllProfilesModal;
  });

  const topNotifications = useSelector(
    ({ notifications }) => notifications?.topNotifications
  );

  // useEffect(() => {
  //   if (!confirmProfileSwitchModal) {
  //     dispatch(setOpenAllProfilesModal(false));
  //   }
  // }, [confirmProfileSwitchModal]);

  useEffect(() => {
    if (userData?.user_id) {
      setIsAuthenticated(true);
      // dispatch(setLoginFirstModalOpen(false));
    } else {
      setIsAuthenticated(false);
      // if (router.pathname !== '/') {
      //   setTimeout(() => {
      //     dispatch(setLoginFirstModalOpen(true));
      //   }, 2000);
      // }
    }
  }, [userDetails]);

  function checkHasNewGiftOrSubscription() {
    if (topNotifications && topNotifications.length > 0) {
      const [item] = topNotifications; // Subscription upgrade, downgrade should be on top
      if (item?.notification_type === 'gift' && item?.read_at === null) {
        setGiftAdDetails(item?.giftAddDetails);
        dispatch(makeReadNotificationsAsync({ id: item?.id, is_top: 1 }));
        return {
          giftAd: true,
          subscriptionDownGrade: false,
          subscriptionUpgrade: false,
        };
      } else if (
        item?.notification_type === 'subscription_downgrade' &&
        item?.read_at === null
      ) {
        setSubscriptionDetails({
          ...item.subscriptionDetails,
          msg: item?.language_msg,
        });
        dispatch(makeReadNotificationsAsync({ id: item?.id, is_top: 1 }));
        return {
          giftAd: false,
          subscriptionDownGrade: true,
          subscriptionUpgrade: false,
        };
      } else if (
        item?.notification_type === 'subscription_upgrade' &&
        item?.read_at === null
      ) {
        setSubscriptionDetails({
          ...item.subscriptionDetails,
          msg: item?.language_msg,
        });
        dispatch(makeReadNotificationsAsync({ id: item?.id, is_top: 1 }));
        return {
          giftAd: false,
          subscriptionDownGrade: false,
          subscriptionUpgrade: true,
        };
      }
    }

    return false;
  }

  useEffect(() => {
    if (topNotifications && topNotifications.length > 0) {
      if (checkHasNewGiftOrSubscription().giftAd === true) {
        setOpenCongratsModal(true);
        setSubscriptionDowngradeModal(false);
        setSubscriptionUpgradeModal(false);
      } else if (
        checkHasNewGiftOrSubscription().subscriptionDownGrade === true
      ) {
        setOpenCongratsModal(false);
        setSubscriptionDowngradeModal(true);
        setSubscriptionUpgradeModal(false);
      } else if (checkHasNewGiftOrSubscription().subscriptionUpgrade === true) {
        setOpenCongratsModal(false);
        setSubscriptionDowngradeModal(false);
        setSubscriptionUpgradeModal(true);
      }
    }
  }, [topNotifications]);

  return (
    <header>
      <TopNav
        userDetails={userDetails}
        isAuthenticated={isAuthenticated}
        isFromLandingPage={isFromLandingPage}
        setOpenNotificationMenu={setOpenNotificationMenu}
      />
      <BottomNav
        userDetails={userDetails}
        isAuthenticated={isAuthenticated}
        openNotificationMenu={openNotificationMenu}
        setOpenNotificationMenu={setOpenNotificationMenu}
      />

      {/* Global Modals */}
      {/* <BetaWarningModal /> */}

      {openAllProfilesModal && (
        <AllProfilesModal
          modalOpen={openAllProfilesModal}
          setModalOpen={(value) => {
            dispatch(setOpenAllProfilesModal(value));
          }}
        />
      )}

      {/* {!isAuthenticated && (
        <LoginFirstModal
          title={lang?.common?.please_sign_up_to_unlock_more_features}
        />
      )} */}
      {openCongratsModal && (
        <GiftAdsNotificationModal
          openModal={openCongratsModal}
          setOpenModal={setOpenCongratsModal}
          giftAdDetails={giftAdDetails}
        />
      )}
      {subscriptionDowngradeModal && (
        <DowngradeSubscriptionNotificationModal
          openModal={subscriptionDowngradeModal}
          setOpenModal={setSubscriptionDowngradeModal}
          data={subscriptionDetails}
        />
      )}
      {subscriptionUpgradeModal && (
        <UpgradeSubscriptionNotificationModal
          openModal={subscriptionUpgradeModal}
          setOpenModal={setSubscriptionUpgradeModal}
          data={subscriptionDetails}
        />
      )}
    </header>
  );
};

export default React.memo(NavBar);
